import { z } from 'zod'

import { apiConn } from '@/services/api/connector'

import {
  FinanceiroOrdemSchema,
  type ModoAtualizar,
  type NovaCobranca,
  RespostaCriacaoSchema,
} from '../domain/financeiro'

const ResultSchema = <T extends z.ZodTypeAny>(schema: T) =>
  z.object({ result: schema })

export const OrdemFinanceiroService = {
  async buscar(orderId: number | string, atualizar: ModoAtualizar) {
    const { data } = await apiConn.get(`entity/orders/${orderId}/financeiro`, {
      params: { atualizar },
    })

    return ResultSchema(FinanceiroOrdemSchema).parse(data).result
  },

  // A chave (Idempotency-Key) identifica a intenção de cobrar: reenviar com a
  // mesma chave nunca cria uma segunda cobrança. `status` é o HTTP (201 criada,
  // 202 nos demais estados).
  async criar(
    orderId: number | string,
    corpo: NovaCobranca,
    idempotencyKey: string,
  ) {
    const response = await apiConn.post(
      `entity/orders/${orderId}/financeiro/contas-a-receber`,
      corpo,
      { headers: { 'Idempotency-Key': idempotencyKey } },
    )

    return {
      status: response.status,
      resposta: ResultSchema(RespostaCriacaoSchema).parse(response.data).result,
    }
  },
}
